import * as React from "react";
import classnames from "classnames";
import { Util } from "@grandvisionhq/common";
import { Skeleton } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { pushImageGalleryZoomEvent } from "../../../../../../../Analytics/events/modules/Analytics/events/ImageGalleryEvents.js";
import { useImageLoaded } from "../../../../../hooks/modules/ProductImageGallery/components/hooks/use-image-loaded.js";
import { ImageZoom } from "./ImageZoom.js";
/* empty css                  */
const defaultImageSizes = {
  M: 768,
  L: 601,
  XL: 877,
  MAX: 877
};
function zoomHandler(altText, sku) {
  let hasFired = false;
  return function() {
    if (!hasFired) {
      hasFired = true;
      pushImageGalleryZoomEvent(altText, sku);
    }
  };
}
const ProductImage = React.forwardRef(
  ({
    altText,
    children,
    className,
    imageParams,
    imageSizes,
    imageUrl,
    onClick,
    showImage = true,
    disableButton = false,
    sku = "",
    zoom = false,
    isOutOfView
  }, ref) => {
    const { getLabel } = useIntl();
    const imageRef = React.useRef(null);
    const [loaded, onLoad] = useImageLoaded(imageRef);
    const imgSizes = zoom && imageSizes ? imageSizes : defaultImageSizes;
    const srcSet = Util.createImageSrcSet(imageUrl, imgSizes, imageParams);
    const sizes = Util.createImageSizes(imgSizes, imageUrl);
    const image = /* @__PURE__ */ React.createElement(
      "img",
      {
        ref: imageRef,
        width: "100%",
        src: imageUrl,
        srcSet,
        sizes,
        alt: altText,
        onLoad,
        className: classnames("product-image__img", className, {
          [`${className}__img`]: !!className
        })
      }
    );
    const ImageWrapper = () => zoom ? /* @__PURE__ */ React.createElement(ImageZoom, { onZoom: zoomHandler(altText, sku) }, image) : /* @__PURE__ */ React.createElement(React.Fragment, null, image);
    const content = () => /* @__PURE__ */ React.createElement(React.Fragment, null, !loaded && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Skeleton,
      {
        height: 210,
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel("common.loadingText")
      },
      /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", rx: "5", fill: "currentColor" })
    ), /* @__PURE__ */ React.createElement("noscript", null, /* @__PURE__ */ React.createElement("img", { src: imageUrl, alt: altText }))), showImage && /* @__PURE__ */ React.createElement(ImageWrapper, null), children);
    if (onClick) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          ref,
          onClick,
          className: classnames("product-image", { [`${className}__wrapper`]: !!className }),
          tabIndex: isOutOfView || disableButton ? -1 : void 0
        },
        content()
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: classnames("product-image", { [`${className}__wrapper`]: !!className }) }, content());
    }
  }
);
export {
  ProductImage
};
//# sourceMappingURL=ProductImage.js.map
